<template>
<!--原因分布-->
  <div class="w-100 h-100 flex flex-column">
    <dv-border-box-12>
      <div class="h-100">
        <div class="w-100 h-100 p-tb" id="issueCause"></div>
      </div>
    </dv-border-box-12>
  </div>
</template>

<script>
export default {
  name: "frCause",
  props: {
    beans: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      dataList: this.beans,
      startCharts: null,
    };
  },
  watch: {
    beans: {
      handler: function (val, oldVal) {
        this.dataList = val;
        this.lineEchart();
      },
      deep: true,
    },
  },
  mounted() {
    // this.lineEchart();
  },
  methods: {
    fontSize(res) {
      let docEl = document.documentElement,
        clientWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;
      if (!clientWidth) return;
      let fontSize = 100 * (clientWidth / 1920);
      return res * fontSize;
    },
    lineEchart() {
      var _this = this;
      var charPiecurrentIndex = 0;
      var chart = this.$echarts.init(
        document.getElementById("issueCause")
      );

      var types = this.dataList;
      var pieData = [];
      types.forEach((re) => {
        pieData.push({ name: re["title"], value: re["count"] });
      });

      var option = {
        title: {
          text: "根本原因分布",
          left: "10",
          textStyle: {
            color: "#ffffff",
            fontSize: this.fontSize(0.22),
          },
        },
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c} ({d}%)",
        },
        legend: {
          // orient: 'vertical',
          // top: 'middle',
          show: true,
          orient: "vertical",
          textStyle: {
            color: "#fff",
            fontSize: this.fontSize(0.12),
          },
          left: "right",
          itemGap: 2,
          itemWidth: 10,
        },
      //  color: ["#09d0fb", "#91CC75", "#95f8fe", "#f9f390", "#ecfeb7"],
			color:['#38EB70', '#F7E16C', '#0EFCFF', '#FD9133', '#4D92F2',"#0090ff","#464aff","#fad81f","#ff605f"],
        series: [
          {
            type: "pie",
            radius: ["55%", "75%"],
            center: ["45%", "52%"],
            avoidLabelOverlap: false,
            data: pieData,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2,
            },
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: this.fontSize(0.22),
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
          },
        ],
      };

      chart.setOption(option);

      // 鼠标移动上去的时候的高亮动画
      chart.on("mouseover", function (param) {
        if (_this.startCharts) {
          clearInterval(_this.startCharts);
        }

        //取消之前高亮图形
        chart.dispatchAction({
          type: "downplay",
          seriesIndex: 0,
          dataIndex: charPiecurrentIndex,
        });
        charPiecurrentIndex = param.dataIndex;
        //高亮当前图形
        chart.dispatchAction({
          type: "highlight",
          seriesIndex: 0,
          dataIndex: param.dataIndex,
        });
        //显示tooltip
        chart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: param.dataIndex,
        });
      });

      //图标随窗口大小缩放
      window.addEventListener("resize", function () {
        chart.resize();
      });

      //自动高亮显示
      var chartHover = function () {
        // console.log(charPiecurrentIndex)
        var dataLen = option.series[0].data.length;

        // 取消之前高亮的图形
        chart.dispatchAction({
          type: "downplay",
          seriesIndex: 0,
          dataIndex: charPiecurrentIndex,
        });
        charPiecurrentIndex = (charPiecurrentIndex + 1) % dataLen;

        // 高亮当前图形
        chart.dispatchAction({
          type: "highlight",
          seriesIndex: 0,
          dataIndex: charPiecurrentIndex,
        });
        // 显示 tooltip
        chart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: charPiecurrentIndex,
        });
      };

      if (_this.startCharts) {
        clearInterval(_this.startCharts);
      }

      _this.startCharts = setInterval(chartHover, 2000);
      // 4、鼠标移出之后，恢复自动高亮
      chart.on("mouseout", function (param) {
        if (_this.startCharts) {
          clearInterval(_this.startCharts);
        }
        _this.startCharts = setInterval(chartHover, 2000);
      });
    },
  },
  destroyed() {
    if (this.startCharts) {
      clearInterval(this.startCharts);
    }
  },
};
</script>


<style scoped>
.item {
  padding: 0.33rem 0.4rem 0.2rem;
}

/*左边中间部分排行榜*/
.biaoge_pai {
  overflow: hidden;
}
.biaoge_pai ul li {
  height: 20%;
}
.biaoge_pai ul li .liIn {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  color: #fff;
  font-size: 0.06rem;
  height: 0.6rem;
}
.biaoge_pai ul li .liIn .liIn_left {
  width: 25%;
  position: relative;
  padding-left: 0.3rem;
}
.biaoge_pai ul li .liIn .liIn_left .bot {
  width: 0.2rem;
  height: 0.2rem;
  background: #91cc75;
  border-radius: 1000px;
  display: block;
  position: absolute;
  left: 0.02rem;
  top: 0;
  bottom: 0;
  margin: auto 0;
}
.biaoge_pai ul li .liIn2 .liIn_left .bot {
  background: #e7feb8;
}
.biaoge_pai ul li .liIn3 .liIn_left .bot {
  background: #fdea8a;
}
.biaoge_pai ul li .liIn4 .liIn_left .bot {
  background: #8ff9f8;
}
.biaoge_pai ul li .liIn5 .liIn_left .bot {
  background: #91cc75;
}
.biaoge_pai ul li .liIn6 .liIn_left .bot {
  background: #05d1fc;
}

.biaoge_pai ul li .liIn .liIn_line {
  width: 58%;
  height: 0.2rem;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 2000px;
}
.biaoge_pai ul li .liIn .liIn_line .line_lineIn {
  width: 100%;
  height: 0.2rem;
  background: #91cc75;
  border-radius: 100px;
  -webkit-animation: widthMove1 2s ease-in-out;
}
.biaoge_pai ul li .liIn2 .liIn_line .line_lineIn {
  background: #e7feb8;
  -webkit-animation: widthMove2 2s ease-in-out;
}
.biaoge_pai ul li .liIn3 .liIn_line .line_lineIn {
  background: #fdea8a;
  -webkit-animation: widthMove3 2s ease-in-out;
}
.biaoge_pai ul li .liIn4 .liIn_line .line_lineIn {
  background: #8ff9f8;
  -webkit-animation: widthMove4 2s ease-in-out;
}
.biaoge_pai ul li .liIn5 .liIn_line .line_lineIn {
  background: #d890fa;
  -webkit-animation: widthMove5 2s ease-in-out;
}
.biaoge_pai ul li .liIn6 .liIn_line .line_lineIn {
  background: #05d1fc;
  -webkit-animation: widthMove6 2s ease-in-out;
}
@-webkit-keyframes widthMove1 {
  0% {
    width: 0%;
  }
  100% {
    width: 98.5%;
  }
}
@-webkit-keyframes widthMove2 {
  0% {
    width: 0%;
  }
  100% {
    width: 88.5%;
  }
}
@-webkit-keyframes widthMove3 {
  0% {
    width: 0%;
  }
  100% {
    width: 68.5%;
  }
}
@-webkit-keyframes widthMove4 {
  0% {
    width: 0%;
  }
  100% {
    width: 40.5%;
  }
}
@-webkit-keyframes widthMove5 {
  0% {
    width: 0%;
  }
  100% {
    width: 22.5%;
  }
}
@-webkit-keyframes widthMove6 {
  0% {
    width: 0%;
  }
  100% {
    width: 10.5%;
  }
}

.biaoge_pai ul li .liIn .num {
  font-family: dig;
  padding-left: 0.1rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/fr/report/8d/component/issue-cause.vue